import { Container, Graphics, Sprite, Texture, Application } from 'pixi.js';

class TrailParticle extends Sprite {
    life: number;
    maxLife: number;
    vx: number;
    vy: number;
    active: boolean;

    constructor(texture: Texture) {
        super(texture);
        this.anchor.set(0.5);
        this.active = false;
    }

    reset(x: number, y: number, color: number, life: number) {
        this.x = x;
        this.y = y;
        this.tint = color;
        this.life = life;
        this.maxLife = life;
        this.vx = (Math.random() - 0.5) * 0.5;
        this.vy = (Math.random() - 0.5) * 0.5;
        this.scale.set(1);
        this.alpha = 1;
        this.active = true;
        this.visible = true;
    }
}

export default class TrailEffect {
    private container: Container;
    private particles: TrailParticle[];
    private particleTexture: Texture;
    private poolSize: number = 100;
    private app: Application;

    constructor(app: Application, container: Container) {
        this.app = app;
        this.container = container;
        this.particles = [];
        
        const g = new Graphics();
        g.circle(0, 0, 4);
        g.fill({ color: 0xFFFFFF });
        
        // Use generateTexture from renderer
        this.particleTexture = this.app.renderer.generateTexture(g);

        for (let i = 0; i < this.poolSize; i++) {
            const p = new TrailParticle(this.particleTexture);
            p.visible = false;
            this.container.addChild(p);
            this.particles.push(p);
        }
    }


    public emit(x: number, y: number, color: number) {
        // Find inactive particle
        const particle = this.particles.find(p => !p.active);
        if (particle) {
            particle.reset(x, y, color, 30 + Math.random() * 10);
        }
    }

    public update(delta: number) {
        for (const p of this.particles) {
            if (p.active) {
                p.x += p.vx * delta;
                p.y += p.vy * delta;
                p.life -= delta;
                p.alpha = p.life / p.maxLife;
                p.scale.set(p.life / p.maxLife);

                if (p.life <= 0) {
                    p.active = false;
                    p.visible = false;
                }
            }
        }
    }
}

